import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';

/**
 * Reducers
 */
import users from './users';
import sidebar from './sidebar';
import refresh from './refresh';
import stations from './stations';
import wheels from './wheels';
import fileImport from './fileImport';
import reports from './reports';
import cars from './cars';

/**
 * Root reducer
 */
export default combineReducers({
    users: users,
    sidebar: sidebar,
    refresh: refresh,
    routing: routerReducer,
    stations : stations,
    wheels: wheels,
    fileImport:fileImport,
    reports:reports,
    cars:cars
});


// WEBPACK FOOTER //
// ./src/reducers/index.js